import { useMemo } from 'react';

import type { SemanticIconType } from '../../common/Icons/SemanticIcons';
import { useAuth } from '../../../auth/AuthProvider';

type NavLink = {
  title: string;
  to: `/${string}`;
  icon: SemanticIconType;
};

/**
 * A list of nav links that are displayed in the navbar.
 */
const defaultNavLinks: NavLink[] = [
  {
    title: 'Workspace',
    to: '/',
    icon: 'Workspace',
  },
  {
    title: 'Knowledge',
    to: '/knowledge',
    icon: 'Knowledge',
  },
];

/**
 * A react hook for providing the nav links to the navbar.
 * @returns
 */
export const useNavLinks = () => {
  const { user } = useAuth();
  const orgRole = (user as Record<string, unknown> | null)?.org_role;

  return useMemo(() => {
    const links = [...defaultNavLinks];
    // Messages link
    links.push({ title: 'Messages', to: '/messages', icon: 'Chat' });
    // Profile is accessible to all authenticated users - shown on right side in desktop, in mobile menu
    links.push({ title: 'Profile', to: '/profile', icon: 'Profile' });
    // Settings is accessible to all authenticated users - shown on right side in desktop, in mobile menu
    links.push({ title: 'Settings', to: '/settings', icon: 'Settings' });
    // Admin is only visible to org admins
    if (orgRole === 'admin') {
      links.push({ title: 'Admin', to: '/admin', icon: 'Settings' });
    }
    // memoizes the nav links so that they are not re-rendered on every render.
    return links;
  }, [orgRole]);
};
